import { useAppDispatch } from "@store";
import { closeDialog } from "@store/dialogs";
import { useCallback } from "react";
import { Button } from "@/shared";

export const Footer = () => {
  const dispatch = useAppDispatch();
  const close = useCallback(() => {
    dispatch(closeDialog("uZknTZTeNMV3lZSLhBSKR"));
  }, [dispatch]);

  return (
    <div className="tw-flex tw-items-center tw-justify-end tw-border-t tw-border-blue-100 tw-bg-blue-100/15 tw-px-4 tw-py-[14px]">
      <Button
        title="Go back"
        size="large"
        variant="secondary"
        onClick={close}
      />
    </div>
  );
};
